/* eslint-disable */
import React from 'react'
import { palette } from '../theme/palette'

export class PrevIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M7 13L1 7L7 1"
          stroke={this.props.color || '#333333'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class NextIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="8" height="14" viewBox="0 0 8 14" fill="none">
        <path
          d="M1 13L7 7L1 1"
          stroke="#333333"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class SendIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M0 9L19 0L10 19L8 11L0 9Z" fill="#0377C4"/>
      </svg>
    )
  }
}

export class DownloadIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="10" height="11" viewBox="0 0 10 11" fill="none">
        <path
          d="M1 7.66602V8.99935C1 9.49027 1.39797 9.88824 1.88889 9.88824H8.11111C8.60203 9.88824 9 9.49027 9 8.99935V7.66602"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.22217 5.44531L4.99995 7.22309L6.77772 5.44531"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5 1V7.22222"
          stroke="#1658F3"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class LineIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="20" height="2" viewBox="0 0 20 2" fill="none">
        <path
          d="M1 1H19"
          stroke={this.props.color || 'rgb(90, 152, 247)'}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class BackIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M17 7H1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 13L1 7L7 1"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ForwardIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="18" height="14" viewBox="0 0 18 14" fill="none">
        <path
          d="M1 7H17"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11 13L17 7L11 1"
          stroke="#B0B2C0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export class ClosePopupIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="17" height="17" viewBox="0 0 17 17" fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.5 16C12.6421 16 16 12.6421 16 8.5C16 4.35786 12.6421 1 8.5 1C4.35786 1 1 4.35786 1 8.5C1 12.6421 4.35786 16 8.5 16Z"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.75 6.25L6.25 10.75"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 6.25L10.75 10.75"
          stroke="#616581"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const CloseWidgetIcon = (props) => (
  <svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 1.41L12.59 0L7 5.59L1.41 0L0 1.41L5.59 7L0 12.59L1.41 14L7 8.41L12.59 14L14 12.59L8.41 7L14 1.41Z" fill={props.color || "#A3B7BF"}/>
  </svg>
)

export const MinusIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5 12H19"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const TreeDotsIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
      stroke="#FAFBFC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
      stroke="#FAFBFC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
      stroke="#FAFBFC"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MiniMazeIcon = ({ width, height, color }) => (
  <svg
    aria-hidden="true"
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M4 14H10V20"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20 10H14V4"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 10L21 3"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21L10 14"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const SoundIcon = () => (
  <svg
    aria-hidden="true"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11 5L6 9H2V15H6L11 19V5Z"
      stroke="#616581"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 9L17 15"
      stroke="#616581"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 9L23 15"
      stroke="#616581"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const MaxiMazeIcon = ({ width, height, color }) => (
  <svg
    aria-hidden="true"
    width={width || '22'}
    height={height || '22'}
    viewBox="0 0 24 24"
    fill="none">
    <path
      d="M3 15V21H9"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 9L21 3L15 3"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 3L14 10"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 21L10 14"
      stroke={color || 'white'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export class LocationIcon extends React.Component {
  render() {
    return (
      <svg aria-hidden="true" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <circle cx="11" cy="11" r="11" fill="#1658F3" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 10.0909C15 13.2727 11 16 11 16C11 16 7 13.2727 7 10.0909C7 7.83156 8.79086 6 11 6C13.2091 6 15 7.83156 15 10.0909V10.0909Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11 11C11.5523 11 12 10.5523 12 10C12 9.44772 11.5523 9 11 9C10.4477 9 10 9.44772 10 10C10 10.5523 10.4477 11 11 11Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
}

export const CopyIcon = props => {
  const { width, height, color } = props
  return (
    <svg
      aria-hidden="true"
      width={width || 20}
      height={height || 20}
      viewBox="0 0 20 20"
      fill="none">
      <path
        d="M17.1998 7.30002H9.0998C8.10569 7.30002 7.2998 8.10591 7.2998 9.10002V17.2C7.2998 18.1941 8.10569 19 9.0998 19H17.1998C18.1939 19 18.9998 18.1941 18.9998 17.2V9.10002C18.9998 8.10591 18.1939 7.30002 17.1998 7.30002Z"
        stroke={color || '#354052'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.7 12.7H2.8C2.32261 12.7 1.86477 12.5104 1.52721 12.1728C1.18964 11.8352 1 11.3774 1 10.9V2.8C1 2.32261 1.18964 1.86477 1.52721 1.52721C1.86477 1.18964 2.32261 1 2.8 1H10.9C11.3774 1 11.8352 1.18964 12.1728 1.52721C12.5104 1.86477 12.7 2.32261 12.7 2.8V3.7"
        stroke={color || '#354052'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const MoreVerticalIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const BurgerMenuIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.02734 8.3208H21.9614C22.3433 8.3208 22.6577 8.01758 22.6577 7.62451C22.6577 7.24268 22.3433 6.93945 21.9614 6.93945H2.02734C1.63428 6.93945 1.33105 7.24268 1.33105 7.62451C1.33105 8.01758 1.63428 8.3208 2.02734 8.3208ZM2.02734 13.0601H21.9614C22.3433 13.0601 22.6577 12.7456 22.6577 12.3638C22.6577 11.9707 22.3433 11.6675 21.9614 11.6675H2.02734C1.63428 11.6675 1.33105 11.9707 1.33105 12.3638C1.33105 12.7456 1.63428 13.0601 2.02734 13.0601ZM2.02734 17.7881H21.9614C22.3433 17.7881 22.6577 17.4849 22.6577 17.0918C22.6577 16.71 22.3433 16.4067 21.9614 16.4067H2.02734C1.63428 16.4067 1.33105 16.71 1.33105 17.0918C1.33105 17.4849 1.63428 17.7881 2.02734 17.7881Z" fill="white"/>
  </svg>
)

export const SendStatusIcon = () => {
  return (
    <svg aria-hidden="true" width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.35355 0.646447C9.54882 0.841709 9.54882 1.15829 9.35355 1.35355L3.85355 6.85355C3.65829 7.04882 3.34171 7.04882 3.14645 6.85355L0.646447 4.35355C0.451184 4.15829 0.451184 3.84171 0.646447 3.64645C0.841709 3.45118 1.15829 3.45118 1.35355 3.64645L3.5 5.79289L8.64645 0.646447C8.84171 0.451184 9.15829 0.451184 9.35355 0.646447Z"
        fill="#B0B2C0"
      />
    </svg>
  )
}

export const ReadStatusIcon = () => {
  return (
    <svg aria-hidden="true" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_92_1706)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.85355 2.64645C9.04882 2.84171 9.04882 3.15829 8.85355 3.35355L3.35355 8.85355C3.15829 9.04882 2.84171 9.04882 2.64645 8.85355L0.146447 6.35355C-0.0488155 6.15829 -0.0488155 5.84171 0.146447 5.64645C0.341709 5.45118 0.658291 5.45118 0.853553 5.64645L3 7.79289L8.14645 2.64645C8.34171 2.45118 8.65829 2.45118 8.85355 2.64645ZM11.8536 2.64645C12.0488 2.84171 12.0488 3.15829 11.8536 3.35355L6.35355 8.85355C6.15829 9.04882 5.84171 9.04882 5.64645 8.85355L5.07747 8.28458C4.88221 8.08932 4.88221 7.77274 5.07747 7.57747C5.27274 7.38221 5.58932 7.38221 5.78458 7.57747L6 7.79289L11.1464 2.64645C11.3417 2.45118 11.6583 2.45118 11.8536 2.64645Z"
          fill="#B0B2C0"
        />
      </g>
      <defs>
        <clipPath id="clip0_92_1706">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const StarIcon = props => {
  return (
    <svg
      aria-hidden="true"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 1L14.09 7.26L21 8.27L16 13.14L17.18 20.02L11 16.77L4.82 20.02L6 13.14L1 8.27L7.91 7.26L11 1Z"
        stroke={props.color || '#B0B2C0'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export const DatepickerPreviousIcon = (props) => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.08 1.99329C10.7534 1.66662 10.2267 1.66662 9.90004 1.99329L4.36004 7.53329C4.10004 7.79329 4.10004 8.21329 4.36004 8.47329L9.90004 14.0133C10.2267 14.34 10.7534 14.34 11.08 14.0133C11.4067 13.6866 11.4067 13.16 11.08 12.8333L6.25337 7.99996L11.0867 3.16662C11.4067 2.84662 11.4067 2.31329 11.08 1.99329Z" fill={props.color || palette.grey60}/>
  </svg>
)

export const DatepickerNextIcon = (props) => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.41088 1.99329C4.73754 1.66662 5.26421 1.66662 5.59088 1.99329L11.1309 7.53329C11.3909 7.79329 11.3909 8.21329 11.1309 8.47329L5.59088 14.0133C5.26421 14.34 4.73754 14.34 4.41088 14.0133C4.08421 13.6866 4.08421 13.16 4.41088 12.8333L9.23755 7.99996L4.40421 3.16662C4.08421 2.84662 4.08421 2.31329 4.41088 1.99329Z" fill={props.color || palette.grey60}/>
  </svg>
)

export const DatepickerDoublePreviousIcon = () => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.24825 1.99329C7.92159 1.66662 7.39492 1.66662 7.06825 1.99329L1.52825 7.53329C1.26825 7.79329 1.26825 8.21329 1.52825 8.47329L7.06825 14.0133C7.39492 14.34 7.92159 14.34 8.24825 14.0133C8.57492 13.6866 8.57492 13.16 8.24825 12.8333L3.42159 7.99996L8.25492 3.16662C8.57492 2.84662 8.57492 2.31329 8.24825 1.99329Z" fill="#A3B7BF"/>
    <path d="M13.5817 1.99329C13.2551 1.66662 12.7284 1.66662 12.4017 1.99329L6.86175 7.53329C6.60175 7.79329 6.60175 8.21329 6.86175 8.47329L12.4017 14.0133C12.7284 14.34 13.2551 14.34 13.5817 14.0133C13.9084 13.6866 13.9084 13.16 13.5817 12.8333L8.75508 7.99996L13.5884 3.16662C13.9084 2.84662 13.9084 2.31329 13.5817 1.99329Z" fill="#A3B7BF"/>
  </svg>
)

export const DatepickerDoubleNextIcon = () => (
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2.24584 1.99329C2.57251 1.66662 3.09917 1.66662 3.42584 1.99329L8.96584 7.53329C9.22584 7.79329 9.22584 8.21329 8.96584 8.47329L3.42584 14.0133C3.09917 14.34 2.57251 14.34 2.24584 14.0133C1.91917 13.6866 1.91917 13.16 2.24584 12.8333L7.07251 7.99996L2.23917 3.16662C1.91917 2.84662 1.91917 2.31329 2.24584 1.99329Z" fill="#A3B7BF"/>
    <path d="M7.57909 1.99329C7.90576 1.66662 8.43242 1.66662 8.75909 1.99329L14.2991 7.53329C14.5591 7.79329 14.5591 8.21329 14.2991 8.47329L8.75909 14.0133C8.43242 14.34 7.90576 14.34 7.57909 14.0133C7.25242 13.6866 7.25242 13.16 7.57909 12.8333L12.4058 7.99996L7.57243 3.16662C7.25243 2.84662 7.25242 2.31329 7.57909 1.99329Z" fill="#A3B7BF"/>
  </svg>
)

export const SelectDateIcon = (props) => (
  <svg aria-hidden="true" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M25.3333 25.3333H6.66667V10.6666H25.3333V25.3333ZM21.3333 1.33325V3.99992H10.6667V1.33325H8V3.99992H6.66667C5.18667 3.99992 4 5.18658 4 6.66658V25.3333C4 26.0405 4.28095 26.7188 4.78105 27.2189C5.28115 27.719 5.95942 27.9999 6.66667 27.9999H25.3333C26.0406 27.9999 26.7189 27.719 27.219 27.2189C27.719 26.7188 28 26.0405 28 25.3333V6.66658C28 5.18658 26.8 3.99992 25.3333 3.99992H24V1.33325" fill={props.color || palette.white}/>
  </svg>
)

export const ChevronDown = (props) => (
  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 7.7168L10 12.7168L15 7.7168" stroke={props.isDisabled ? palette.mediumGray : palette.mainText} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export const ConditionStatusIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z" fill={palette.disabledElement}/>
  </svg>
)

export const ConditionStatusDoneIcon = () => (
  <svg aria-hidden="true" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 11.4477 20.4477 11 21 11C21.5523 11 22 11.4477 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C13.3321 2 14.6057 2.261 15.7707 2.7356C16.2822 2.94396 16.5279 3.5275 16.3195 4.03897C16.1112 4.55044 15.5276 4.79616 15.0162 4.5878C14.0867 4.20914 13.069 4 12 4Z" fill={palette.mainBlue}/>
    <path fillRule="evenodd" clipRule="evenodd" d="M21.7129 4.29876C22.1002 4.6925 22.095 5.32564 21.7012 5.71293L12.5512 14.7129C12.1621 15.0957 11.5379 15.0957 11.1488 14.7129L8.29876 11.9096C7.90502 11.5224 7.89979 10.8892 8.28707 10.4955C8.67436 10.1017 9.3075 10.0965 9.70124 10.4838L11.85 12.5973L20.2988 4.28707C20.6925 3.89979 21.3256 3.90502 21.7129 4.29876Z" fill={palette.mainBlue}/>
  </svg>
)

export const BubbleTail = props => {
  return (
    <svg aria-hidden="true" width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_358_6385)">
        <rect width="7" height="10" />
        <mask id="path-1-inside-1_358_6385" fill="white">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M-40 -30C-47.732 -30 -54 -23.732 -54 -16V-4C-54 3.73199 -47.732 10 -40 10H1L6.29412 10C6.29412 10 7 10 7 9.28572C7 8.57143 6.29412 8.57143 6.29412 8.57143C2.76471 7.67857 1 3.21429 1 0V-16C1 -23.732 -5.26801 -30 -13 -30H-40Z"/>
        </mask>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M-40 -30C-47.732 -30 -54 -23.732 -54 -16V-4C-54 3.73199 -47.732 10 -40 10H1L6.29412 10C6.29412 10 7 10 7 9.28572C7 8.57143 6.29412 8.57143 6.29412 8.57143C2.76471 7.67857 1 3.21429 1 0V-16C1 -23.732 -5.26801 -30 -13 -30H-40Z" fill="#E8F8FD" />
        <path d="M1 10L1 11L1 11L1 10ZM6.29412 10L6.29413 9L6.29412 9L6.29412 10ZM6.29412 8.57143L6.04887 9.54089L6.16959 9.57143H6.29412V8.57143ZM-53 -16C-53 -23.1797 -47.1797 -29 -40 -29V-31C-48.2843 -31 -55 -24.2843 -55 -16H-53ZM-53 -4V-16H-55V-4H-53ZM-40 9C-47.1797 9 -53 3.1797 -53 -4H-55C-55 4.28427 -48.2843 11 -40 11V9ZM1 9H-40V11H1V9ZM6.29412 9L0.999999 9L1 11L6.29412 11L6.29412 9ZM6 9.28572C6 9.29171 6.00124 9.22957 6.05465 9.1485C6.10431 9.07312 6.1643 9.03426 6.19561 9.01842C6.22275 9.00468 6.23798 9.00278 6.23812 9.00276C6.24053 9.00235 6.24477 9.00175 6.25237 9.0012C6.25634 9.00092 6.26158 9.00062 6.26834 9.00039C6.27174 9.00028 6.27556 9.00018 6.27983 9.00011C6.28197 9.00007 6.28423 9.00004 6.28661 9.00003C6.2878 9.00002 6.28902 9.00001 6.29027 9C6.2909 9 6.29153 9 6.29218 9C6.2925 9 6.29299 9 6.29315 9C6.29364 9 6.29413 9 6.29412 10C6.29411 11 6.2946 11 6.2951 11C6.29528 11 6.29578 11 6.29612 11C6.29681 11 6.29751 11 6.29822 11C6.29964 11 6.30112 11 6.30265 11C6.30571 10.9999 6.30898 10.9999 6.31245 10.9998C6.31939 10.9997 6.32718 10.9995 6.33574 10.9993C6.35285 10.9987 6.37326 10.9977 6.39653 10.996C6.44273 10.9927 6.50211 10.9865 6.5707 10.9749C6.7032 10.9526 6.89489 10.906 7.09851 10.803C7.30629 10.6979 7.54275 10.5251 7.72476 10.2488C7.91053 9.96687 8 9.63686 8 9.28572H6ZM6.29412 8.57143C6.29412 9.57143 6.29362 9.57143 6.29313 9.57143C6.29297 9.57143 6.29249 9.57143 6.29217 9.57143C6.29152 9.57143 6.29089 9.57143 6.29026 9.57142C6.28901 9.57142 6.28779 9.57141 6.2866 9.5714C6.28422 9.57138 6.28196 9.57135 6.27982 9.57132C6.27555 9.57125 6.27173 9.57115 6.26833 9.57104C6.26157 9.57081 6.25633 9.57051 6.25236 9.57022C6.24476 9.56967 6.24052 9.56907 6.23811 9.56867C6.23797 9.56864 6.22274 9.56674 6.1956 9.55301C6.16429 9.53717 6.10431 9.49831 6.05464 9.42293C6.00124 9.34187 6 9.27972 6 9.28572H8C8 8.93457 7.91053 8.60457 7.72477 8.32261C7.54275 8.04634 7.3063 7.87355 7.09852 7.76842C6.8949 7.6654 6.70321 7.61886 6.57071 7.59652C6.50212 7.58495 6.44274 7.57877 6.39654 7.57543C6.37327 7.57375 6.35286 7.57275 6.33576 7.57217C6.32719 7.57188 6.31941 7.5717 6.31246 7.57159C6.30899 7.57153 6.30572 7.57149 6.30266 7.57147C6.30113 7.57145 6.29965 7.57144 6.29823 7.57144C6.29752 7.57144 6.29682 7.57143 6.29613 7.57143C6.29579 7.57143 6.29529 7.57143 6.29512 7.57143C6.29461 7.57143 6.29412 7.57143 6.29412 8.57143ZM0 0C0 1.76825 0.480214 3.85225 1.44418 5.63242C2.4068 7.41013 3.92157 9.00273 6.04887 9.54089L6.53937 7.60197C5.13725 7.24727 4.00496 6.1613 3.20288 4.68008C2.40214 3.20133 2 1.44603 2 0H0ZM0 -16V0H2V-16H0ZM-13 -29C-5.8203 -29 0 -23.1797 0 -16H2C2 -24.2843 -4.71573 -31 -13 -31V-29ZM-40 -29H-13V-31H-40V-29Z" fill="#1EB4EE" mask="url(#path-1-inside-1_358_6385)"/>
      </g>
      <defs>
        <clipPath id="clip0_358_6385">
          <rect width="7" height="10" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  )
}

export const StarRating = (props) => {
  return (
    <svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.0007 25.65L13.734 29.4334L15.384 22.3L9.85065 17.5L17.1507 16.8834L20.0007 10.15L22.8507 16.8834L30.1507 17.5L24.6173 22.3L26.2673 29.4334M36.6673 15.4L24.684 14.3834L20.0007 3.33337L15.3173 14.3834L3.33398 15.4L12.4173 23.2834L9.70065 35L20.0007 28.7834L30.3007 35L27.5673 23.2834L36.6673 15.4Z" fill={props.color || palette.mainBlue}/>
    </svg>
  )
}

export const StarRatingFill = (props) => {
  return (
    <svg aria-hidden="true" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20.0007 28.7834L30.3007 35L27.5673 23.2834L36.6673 15.4L24.684 14.3667L20.0007 3.33337L15.3173 14.3667L3.33398 15.4L12.4173 23.2834L9.70065 35L20.0007 28.7834Z" fill={props.color || palette.mainBlue}/>
    </svg>
  )
}

export const ExternalLinkIcon = (externalLinkIconAriaLabel) => {
  return (
    `<svg role="img" aria-label="${externalLinkIconAriaLabel}" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 7.58333V11.0833C10.5 11.3928 10.3771 11.6895 10.1583 11.9083C9.9395 12.1271 9.64275 12.25 9.33333 12.25H2.91667C2.60725 12.25 2.3105 12.1271 2.09171 11.9083C1.87292 11.6895 1.75 11.3928 1.75 11.0833V4.66667C1.75 4.35725 1.87292 4.0605 2.09171 3.84171C2.3105 3.62292 2.60725 3.5 2.91667 3.5H6.41667" stroke="#0377C4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.75 1.75H12.25V5.25" stroke="#0377C4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.83301 8.16667L12.2497 1.75" stroke="#0377C4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>`
  )
}

